import { render, staticRenderFns } from "./RecalledChallenge.vue?vue&type=template&id=927e23fa&scoped=true&"
import script from "./RecalledChallenge.vue?vue&type=script&lang=ts&"
export * from "./RecalledChallenge.vue?vue&type=script&lang=ts&"
import style0 from "./RecalledChallenge.vue?vue&type=style&index=0&id=927e23fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927e23fa",
  null
  
)

export default component.exports